import { apiFetcher } from "./apiFetcher";
import ecommercePlatforms from "../../utils/ecommercePlatforms";
import qs from "qs";

export const trayService = {
    getProducts,
    getProductById,
    getProductVariants,
    searchProducts,
    getAllCategories
};

function ns(platformId) {
    return ecommercePlatforms.getProfileById(platformId)?.apiNamespace ?? platformId;
}

function getProducts(platformId, storeId, options) {
    const url = `platforms/${ns(platformId)}/api_forward/${storeId}/products?${qs.stringify(options.filters)}`;

    return apiFetcher(url, { method: "GET" });
}

function getProductById(platformId, storeId, productId) {
    return apiFetcher(`platforms/${ns(platformId)}/api_forward/${storeId}/products/${productId}`, {
        method: "GET"
    }).then(response => {
        return response.Product;
    });
}

function getProductVariants(platformId, storeId, productId) {
    return apiFetcher(
        `platforms/${ns(platformId)}/api_forward/${storeId}/variants?limit=50&product_id=${productId}`,
        {
            method: "GET"
        }
    ).then(response => {
        return response.Variants;
    });
}

function searchProducts(platformId, storeId, options) {
    const url = `platforms/${ns(platformId)}/api_forward/${storeId}/search?query=${options.query}&${qs.stringify(options.filters)}`;

    return apiFetcher(url, { method: "GET" });
}

function getAllCategories(platformId, storeId, options) {
    const url = `platforms/${ns(platformId)}/api_forward/${storeId}/categories/tree?active=1&${qs.stringify(options.filters)}`;

    return apiFetcher(url, { method: "GET" });
}
